var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 1560 1040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fad201",
    d: "M0 0h1560v1040H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a3e0",
    d: "M0 0h1560v520H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#20603d",
    d: "M0 780h1560v260H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1280 272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e5be01",
    d: "M0-168 6.79-51.56l36.69-110.72L19.9-48.04 84-145.49 31.66-41.25l87.13-77.54-77.54 87.13L145.49-84 48.04-19.9l114.24-23.58L51.56-6.79 168 0 51.56 6.79l110.72 36.69L48.04 19.9 145.49 84 41.25 31.66l77.54 87.13-87.13-77.54L84 145.49 19.9 48.04l23.58 114.24L6.79 51.56 0 168-6.79 51.56l-36.69 110.72L-19.9 48.04-84 145.49l52.34-104.24-87.13 77.54 77.54-87.13L-145.49 84l97.45-64.1-114.24 23.58L-51.56 6.79-168 0l116.44-6.79-110.72-36.69L-48.04-19.9-145.49-84l104.24 52.34-77.54-87.13 87.13 77.54L-84-145.49l64.1 97.45-23.58-114.24L-6.79-51.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#00a3e0",
    r: 49,
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/rw.581157c6a9dc929b14420b750fa278c6.svg";
export { ForwardRef as ReactComponent };